import Swiper from 'swiper'

export default {
  props: {
    options: Object
  },

  mounted() {
    this.init();
  },

  beforeDestroy() {
    this.$swiper.destroy();
  },
  methods: {
    /**
     * Initialize a new flickity and emit init event.
     */
    init() {
      this.$swiper = new Swiper(this.$el, this.options);
      this.$emit('init', this.$swiper);
    },

    /**
     * Return the current swiper instance to access directly
     *
     * @return {Swiper}
     */
    swiper() {
      return this.$swiper;
    },

    /**
     * Selecting Slides
     */

    /**
     * Select a slide
     *
     * @param {number} index
     * @param {boolean} isWrapped
     * @param {boolean} isInstant
     */
    select(index) {
      this.$swiper.slideTo(index);
    },

    /**
     * Change to the next slide
     *
     * @param {boolean} isWrapped
     * @param {boolean} isInstant
     */
    next() {
      this.$swiper.slideNext();
    },

    /**
     * Change to the previous slide
     */
    previous() {
      this.$swiper.slidePrev();
    },

    /**
     * Sizing and Positioning
     */

    /**
     * Trigger a resize event
     */
    resize() {
      this.$swiper.updateSize();
    },

    /**
     * Trigger a reposition event
     */
    reposition() {
      this.$swiper.updateSlides();
    },

    /**
     * Trigger a rerender event
     */
    rerender() {
      this.$swiper.destroy();
      this.init();
    },
    /**
     * Destroy the flickity instance
     */
    destroy() {
      this.$swiper.destroy();
    },
  },
  template: `
  <div>
    <slot />
  </div>`,
};
